/* @flow */
import React from 'react';

import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import OrganizationProfileTeachers from 'collections/OrganizationProfileTeachers';
import { redirector } from 'auth/components/SignInPage.jsx';
import ToastActions from 'actions/ToastActions';
import { mountModal } from 'lib/modal';

import SchoolReportModal from './SchoolReportModal.jsx';
import SchoolTeacherListItem from './SchoolTeacherListItem.jsx';

import './styles/SchoolTeacherList.scss';

class SchoolTeacherList extends React.Component {
  static propTypes = {
    redirect: React.PropTypes.func.isRequired,
    teachers: React.PropTypes.instanceOf(OrganizationProfileTeachers).isRequired,
    schoolName: React.PropTypes.string.isRequired,
    organizationId: React.PropTypes.number.isRequired,
    location: React.PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (this.props.location.query.report) {
      this.displayReportModal();
    }
  }

  displayReportModal = () => {
    mountModal(
      <SchoolReportModal schoolName={this.props.schoolName} teachers={this.props.teachers} />,
      this
    );
  };

  redirectToSignIn = () => {
    // XXX
    redirector.onSignInRedirectTo = {
      pathname: `/school/${this.props.organizationId}`,
      query: { report: true },
    };
    ToastActions.showSuccessToast('You must sign in to report.');
    this.context.router.push('/log_in');
  };

  render() {
    const { teachers } = this.props;

    if (!teachers || teachers.length === 0) {
      return (
        <div className="SchoolTeacherList-empty">
          <h2>Are you a member of the {this.props.schoolName} community?</h2>

          <Button
            className="SchoolTeacherList-empty-signUpButton"
            onClick={this.props.redirect}
            eventElementName="SchoolTeacherList-empty-signUpButton">
            Sign up for Remind
          </Button>
        </div>
      );
    }

    const teacherList = teachers.map(teacher => {
      return (
        <SchoolTeacherListItem
          key={teacher.id}
          teacher={teacher}
          onGroupAvatarClick={this.props.redirect}
        />
      );
    });

    return (
      <div>
        <h3 className="SchoolTeacherList-title">
          Teachers on Remind at {this.props.schoolName}
        </h3>
        <div className="SchoolTeacherList">
          {teacherList}
        </div>
        <span className="SchoolTeacherList-report">
          <Link
            onClick={CurrentUser.isSignedIn() ? this.displayReportModal : this.redirectToSignIn}>
            <Glyph name="flag" size="small" />
            See an error in the list? Report to Remind
          </Link>
        </span>
      </div>
    );
  }
}

export default SchoolTeacherList;



// WEBPACK FOOTER //
// ./src/schools/components/SchoolTeacherList.jsx